import { JWT_KEY } from "Auth/Models/AuthConstants";
import { ApiCallError, HttpStatus } from "Infrastructure/Api/ApiUtils";
import { client } from "Infrastructure/Api/generated/client.gen";
import type { ApiProblemDetails } from "Infrastructure/Api/generated/types.gen";
import { trackUserIdentification } from "Infrastructure/Utils/TrackingUtils";

export const AUTH_UNAUTHORIZED_EVENT = "auth:unauthorized";

client.interceptors.request.use((request) => {
	const token = localStorage.getItem(JWT_KEY);
	if (token && !request.headers.has("Authorization")) {
		request.headers.set("Authorization", token);
	}
	return request;
});

client.interceptors.response.use((response) => {
	if (response.ok) {
		trackUserIdentification();
	} else if (response.status === HttpStatus.Unauthorized) {
		// Fire forced-sign-out only when we *had* a token — a 401 for an
		// anonymous request (e.g. user-info probe on the sign-in page) is
		// expected and would otherwise cause an event/refetch loop.
		// App.tsx listens to this event and runs processSignOut(queryClient).
		// We deliberately don't import processSignOut here — it needs the
		// QueryClient instance owned by App.tsx, which would create a cycle.
		if (localStorage.getItem(JWT_KEY) !== null) {
			window.dispatchEvent(new CustomEvent(AUTH_UNAUTHORIZED_EVENT));
		}
	}
	return response;
});

client.interceptors.error.use((error, response, _request, options) => {
	const url =
		typeof options.url === "string"
			? options.url
			: ((options as { url?: unknown }).url?.toString() ?? "");
	const body =
		error !== null && typeof error === "object"
			? (error as ApiProblemDetails)
			: null;
	return new ApiCallError(response?.status ?? 0, body, url);
});
